import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentsGuard implements CanActivate {
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  constructor (private router : Router,private toast: HotToastService,private translationService: TranslationService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const authData = JSON.parse(localStorage.getItem(this.authLocalStorageToken));
      const language = this.translationService.getSelectedLanguage();

      if (!authData.roles.includes('Appointments'))
      {
        if (language == 'ar')
        {
          this.toast.error("<b>ليس لديك صلاحية لهذه الخدمة</b>", { style: { padding: '20px' } });
        }
        else
        {
          this.toast.error("<b>You do not have permission for this service</b>", { style: { padding: '20px' } });

        }
        this.router.navigate(['/portal/dashboard']);
        return false;
      }
    return true;
  }

}
